import { useQuery } from '@apollo/client';

import { BugTracker } from 'kb-shared/utilities/bugTracker';

import { QUERY_ADDRESS_DETAILS } from '../SignUpForm.graphql';
import { PredictedAddressesDetailsResponse } from '../SignUpForm.types';

export const useAddressDetails = (input?: string, city?: string, stateId?: string) => {
  const { data } = useQuery<PredictedAddressesDetailsResponse>(QUERY_ADDRESS_DETAILS, {
    variables: {
      input,
      city,
      stateId
    },
    skip: !input,
    onError: error => {
      BugTracker.notify(error, 'Failed to load address details (ZIP and timezone)');
    }
  });

  return { addressDetails: data?.findZips };
};
